import { render, staticRenderFns } from "./OurPartnersPage.vue?vue&type=template&id=47da8522&scoped=true&"
import script from "./OurPartnersPage.vue?vue&type=script&lang=js&"
export * from "./OurPartnersPage.vue?vue&type=script&lang=js&"
import style0 from "./OurPartnersPage.vue?vue&type=style&index=0&id=47da8522&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47da8522",
  null
  
)

export default component.exports